import { render, staticRenderFns } from "./gc-popup-invoice-balance-history.vue?vue&type=template&id=1287d86e"
import script from "./gc-popup-invoice-balance-history.vue?vue&type=script&lang=js"
export * from "./gc-popup-invoice-balance-history.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-invoice-balance-history.vue?vue&type=style&index=0&id=1287d86e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports